'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BibBlock = require('./components/BibBlock.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_BibBlock).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/availability-bib-block/lib/index.js
// module id = 1168
// module chunks = 0